var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoverphoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{mix-blend-mode:multiply;}.cls-3{fill:#e2bc00;}.cls-4{fill:#093357;}.cls-5{fill:#7569b0;}.cls-6{fill:#d4dfe9;}.cls-7{fill:none;stroke:#093357;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px;}.cls-8{fill:#489de3;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "person") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons",
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M45,79c-15,4-21,6-21,16v19a2,2,0,0,0,2,2H64V84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M83,79c15,4,21,6,21,16v19a2,2,0,0,1-2,2H64V84Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 64,
    cy: 89,
    r: 5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M85.463,44c6.064-9.813,8.085-24.533-7.074-26.5-1.011-5.888-9.908-6.57-17.7-4.306-5.12,1.488-13.634,1.888-18.117-.342a1,1,0,0,0-1.445.636c-.62,2.549-1.478,8.125,2.382,9.643-7.074,2.981-7.074,13.91-1.5,19.884"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M84,47c0-16.016-2-29-20-29S44,30.984,44,47s6,29,20,29S84,63.016,84,47Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 44,
    cy: 45,
    r: 4
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 84,
    cy: 45,
    r: 4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M44.006,40.375C44.132,33.705,46.45,29.03,61,30c10.894.726,13.349-2.767,13.876-4.734a1,1,0,0,1,1.457-.621C78.839,26.1,84,30.4,84,41l2-4S84,16,61,16c-8,0-21,9-18,24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M63,64.8A6.915,6.915,0,0,0,71,61"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 52,
    y: 70,
    width: 24,
    height: 14
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M52,77l-7,2L57.185,91.185a1,1,0,0,0,1.507-.107L64,84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M76,77l7,2L70.815,91.185a1,1,0,0,1-1.507-.107L64,84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M64,90l-5.953,18.276a.963.963,0,0,0,.156.89l4.982,6.44a1.038,1.038,0,0,0,1.629,0l4.982-6.44a.963.963,0,0,0,.156-.89Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoverphoto);
export default __webpack_public_path__ + "static/media/coverphoto.27f3141c99a681606b3c56bb74749e1f.svg";
export { ForwardRef as ReactComponent };